import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const ActionTypes = Constants.ActionTypes;

module.exports = {

  receiveConversations(conversations, unread_conversations) {
    AppDispatcher.dispatch({
      type: ActionTypes.CONVERSATIONS_LOAD_SUCCESS,
      conversations,
      unread_conversations,
    });
  },

};
